<div class="min-h-screen bg-gradient-to-br from-blue-400 to-blue-700">
  <ng-container *ngIf="showShell; else bareOutlet">
    <app-sidebar [mode]="sidebarMode" (modeChange)="onSidebarModeChange($event)"></app-sidebar>

    <div
      class="flex flex-col h-screen transition-all duration-300"
      [ngClass]="{ 'ml-56': sidebarMode === 'large', 'ml-20': sidebarMode === 'small' }">
      <app-navbar></app-navbar>

      <main class="flex-1 overflow-auto pr-6 pb-6">
        <router-outlet />
      </main>
    </div>
  </ng-container>

  <ng-template #bareOutlet>
    <router-outlet />
  </ng-template>
</div>
